import React, { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { GetProductByServiceUrlAPI } from "./api/productsApi";
import { Loader } from "./components/Loader/Loader";
import "./core/core.css";
import ProtectedRoute from "./pages/ProtectedRoute";
// Импортируем компоненты страниц
const Main = React.lazy(() => import("./pages/mainPage"));
const Payment = React.lazy(() => import("./pages/uslugi/payment_page"));
const Uslugi = React.lazy(() => import("./pages/uslugi"));
const Usluga = React.lazy(() => import("./pages/usluga"));
const Blog = React.lazy(() => import("./pages/blog"));
const Info = React.lazy(() => import("./pages/info"));
const Login = React.lazy(() => import("./pages/account/login"));
const Account = React.lazy(() => import("./pages/account/profile"));
const Order = React.lazy(() => import("./pages/account/order"));
const router = createBrowserRouter([
  {
    path: "/",
    element: <Main />,
  },
  {
    path: "/uslugi/",
    element: <Uslugi />,
  },
  {
    path: "/uslugi/:url/",
    element: <Usluga />,
    loader: async ({ params }) => {
      if (!params.url) throw new Error("URL is required");
      return await GetProductByServiceUrlAPI({ service_url: params.url });
    },
  },
  {
    path: "/uslugi/:url/payment/",
    element: <Payment />,
    loader: async ({ params }) => {
      if (!params.url) throw new Error("URL is required");
      return await GetProductByServiceUrlAPI({ service_url: params.url });
    },
  },
  {
    path: "/blog/",
    element: <Blog />,
  },
  {
    path: "/blog/:url/",
    element: <Info />,
  },

  {
    path: "/account/",
    element: (
      <ProtectedRoute>
        <Account />
      </ProtectedRoute>
    ),
  },
  {
    path: "/account/order/:order_id/",
    element: (
      <ProtectedRoute>
        <Order />
      </ProtectedRoute>
    ),
  },
  {
    path: "/account/login/",
    element: <Login />,
  },
  {
    path: "/podborki/:url/",
    element: <Uslugi />,
  },
]);
const App = () => {
  return (
    <Suspense fallback={<Loader isLoading isPage></Loader>}>
      <RouterProvider router={router} />
    </Suspense>
  );
};

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
